import {useEffect, useState} from "react";
import {useSearchParams, useNavigate} from "react-router-dom";
import {useSnackbar} from "notistack";
import {DataGridPro, getGridStringOperators} from "@mui/x-data-grid-pro";
import {Box, Button} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import sendRequest from "../services/sendRequest";
import getOptions from "../services/getOptions";
import EditDataChannel from "../components/editDataChannel";
import GetAssetIds from "../components/getAssetIds";
import UploadAssetIds from "../components/uploadAssetIds";
import CustomToolbar from "../components/customToolbar";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const CustomIdsPerChannelPage = ({
  page,
  columnsToShow,
  defaultParams,
  customColumns = {},
}) => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const [searchParams, setSearchParams] = useSearchParams({});
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editOrder, setEditOrder] = useState([]);
  const [columns, setColumns] = useState();
  const [columnVisibilityModel, setColumnVisibilityModel] = useState();
  const [options, setOptions] = useState({});
  const [rowToEdit, setRowToEdit] = useState({});
  const [isAdd, setIsAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(500);
  const [openEdit, setOpenEdit] = useState(false);
  const [selected, setSelected] = useState([]);
  const [listOfClients, setListOfClients] = useState([]);
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);
  const [time, setTime] = useState(0);  
  const [selectedRows, setSelectedRows] = useState([]);
  const [openAssetsDataExport, setOpenAssetsDataExport] = useState(false);
  const [openAssetsDataUpload, setOpenAssetsDataUpload] = useState(false);
  const [sortModel, setSortModel] = useState([
    {
      field: "id",
      sort: page === "job" ? "desc" : "asc",
    },
  ]);
  const role=localStorage.getItem("role")
  console.log("ChannelPage",page)
  console.log("ChannelPage",data)
  localStorage.setItem('page',page)

  useEffect(() => {
    let fetched = false;
    async function getData() {
      setLoading(true);
      if(page==="users")
        await getOptions("permission");
      const metadata = await getOptions(page);
      console.log("metadatametadatametadata",metadata)
      if (!metadata) {
        handleAllTypesOfMessages("Failed to load Data Options!", "error");
        return;
      }
      setOptions(metadata);
       if (metadata && metadata.client && metadata.client.options) {
        setListOfClients(metadata.client.options);
      }

      const cols = await createColumns(metadata);
      setColumns(cols);

      const cvm = await createColumnVisibilityModel(metadata);
      setColumnVisibilityModel(cvm ?? false);

      const notReadOnly = Object.entries(metadata)
        .filter(([_, v]) => !v.read_only)
        .map(([k, _]) => k);
      setEditOrder(notReadOnly);
      let response=[];
      
      response = await sendRequest({
        requestType: "get",
        endpoint: `${page}/?${
          page === "task" ? "latest=true&" : ""
        }${searchParams.toString()}`,
      });

      console.log(response);

      if (
        page === "task" &&
        response.data.some(
          (item) => item.status === "running" || item.status === "queued"
        )
      ) {
        setRefresh((oldState) => !oldState);
      }
      if (response.code) {
        handleAllTypesOfMessages("Failed to load Data!", "error");
      } else {
        if (page != "programmes") {
          setData(response.data);
        }
      }
    }

    if (fetched) return;
    getData().finally(() => setLoading(false));
    return () => (fetched = true);
  }, [page, refresh]);

  const createColumnVisibilityModel = async (ops) => {
    const model = {};    
    // Filter out the 'id' column from columnsToShow
    const filteredColumnsToShow = columnsToShow?.filter((column) => column !== "id");

    Object.keys(ops).forEach((columnName) => {
      if (filteredColumnsToShow && !filteredColumnsToShow.includes(columnName))
        model[columnName] = false;
    });
    return model;
  };

  const createColumns = async (ops) => [
    ...Object.keys(ops).map((header) => {
      let currentCol = {
        field: header,
        headerName: ops[header].label,
        flex: 1,
      };

      if (header in customColumns) {
        currentCol = {...currentCol, ...customColumns[header]};
      }
      return currentCol;
    }),
    ...(page === "job"
      ? [
          {
            field: "",
            headerName: "View",
            width: 150,

            renderCell: ({row}) => (
              <Button onClick={() => viewJob(row)}>View</Button>
            ),
          },
        ]
      : page === "quarterly_report" || role != "full access"
      ? []
      : [
          {
            field: "",
            headerName: "Edit",
            width: 150,
            filterable: false,
            renderCell: ({row}) => (
              <EditIcon onClick={() => openEditDialogue(row)} />
            ),
          },
        ]),
  ];

  const viewJob = (job) => {
    if (job?.id) {
      navigate(`/task?job=${job.id}`);
    } else {
      handleAllTypesOfMessages("Invalid Job ID", "warning");
    }
  };

  const openEditDialogue = async (rowToEdit) => {
    if (!rowToEdit) {
      setOpenEdit(false);
    } else if (rowToEdit === "add") {
      setOpenEdit(true);
      setIsAdd(true);
      setRowToEdit(rowToEdit);
    } else {
      localStorage.setItem('entity_id', null);
      setOpenEdit(true);
      setIsAdd(false);
      setRowToEdit(rowToEdit);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  const handlePageSizeChange = (pageSizeNumber) => {
    setPageSize(pageSizeNumber);
  };

  if (!columns) {
    return null;
  }

  const handleClickOpen = () => {
    setOpen(true);
  };  
 
  const defaultId = (row) => {
    if (defaultParams && "row_id" in defaultParams)
      return defaultParams["row_id"];
    return row.id
      ? row.id
      : row.custom_id_stem
      ? row.custom_id_stem
      : row.custom_id;
  };

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };
  
  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(key)}
      >
      <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  const setOpenDealsProgrammeExport = () => {
    setOpenAssetsDataExport(false)
    setSelectedRows([]);
    setSelected([])
    setEntries([]);
  };

  const setOpenDealsProgrammeUpload = () => {
    setOpenAssetsDataUpload(false)
    setSelectedRows([]);
    setSelected([])
    setEntries([]);
  };

  const selectedRowsForAssetAndUnknowAsset = (model) => {
    if(page === 'customIdsPerChannel') {
      const seledtedRows = data.filter((x) => model.some((y) => y === x.id));
      setSelectedRows(seledtedRows)
    }
  };

  
  return (
    <>

      <Box sx={{height: "100%", width: "100%"}}>
        <DataGridPro
          columns={columns ? columns : []}
          rows={data ? data : []}
          rowCount={data ? data?.data?.count : 0}
          sortModel={sortModel}
          pageSize={pageSize}
          rowsPerPageOptions={[100, 500, 5000]}
          onPageSizeChange={handlePageSizeChange}
          checkboxSelection
          disableSelectionOnClick
          columnVisibilityModel={{...columnVisibilityModel}}
          onColumnVisibilityModelChange={(model) =>
            setColumnVisibilityModel(model)
          }
          getRowId={defaultId}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterExcludeHiddenColumns: true,
              },
            },
          }}
          experimentalFeatures={{aggregation: true}}
          loading={loading}
          pagination
          page={pageNumber}
          onPageChange={handlePageChange}
          components={{Toolbar: CustomToolbar}}
          onSelectionModelChange={(model) => {
            selectedRowsForAssetAndUnknowAsset(model);
            setEntries(model);
          }}
          componentsProps={{
            toolbar: {
              openEditDialogue,
              page,
              selected,
              open,
              selectedRows,
              setOpenAssetsDataExport,
              setOpenAssetsDataUpload,
            },
          }}
          selectionModel={entries}
        />
        <EditDataChannel
          open={openEdit}
          openEditDialogue={openEditDialogue}
          options={options}
          order={editOrder}
          rowToEdit={rowToEdit}
          isAdd={isAdd}
          page={defaultParams?.["edit_endpoint"] ?? page}
          setRefresh={setRefresh}
        />
        <GetAssetIds
          open={openAssetsDataExport}
          close={() => setOpenDealsProgrammeExport(false)}
          selectedRows={selectedRows}
          selectedColumns={columnVisibilityModel}
        ></GetAssetIds>

        <UploadAssetIds
          open={openAssetsDataUpload}
          close={() => setOpenDealsProgrammeUpload(false)}
          selectedRows={selectedRows}
          selectedColumns={columnVisibilityModel}
        ></UploadAssetIds>
        
      </Box>
    </>
  );
};

export default CustomIdsPerChannelPage;
